import { UpsertLocationAlarmIncidentResponseDTO } from '@hakimo-ui/hakimo/types';

/**
 * Whether a create returned an incident that already existed rather than making
 * a new one. Escalating a second alarm in the same scope is not an error: the
 * backend answers 200 with the group's existing incident, so the operator must
 * not be told a new escalation was raised.
 *
 * Matched on the message because both responses are 200 with the same fields.
 * Kept loose, and worth replacing with an explicit `created` flag if the
 * backend adds one.
 */
export function isExistingIncidentResponse(
  data?: UpsertLocationAlarmIncidentResponseDTO
): boolean {
  return !!data?.message?.toLowerCase().includes('already exists');
}

/**
 * Whether a resolve failed because the incident was already closed. v3 only:
 * the v3 controller answers 400 when `resolved_by` is set, and v2 has no such
 * path.
 *
 * Worth distinguishing because several alarms share one incident under
 * source-group scoping, so operators on sibling alarms race routinely -- that
 * is not a system failure. Matched on wording, so kept loose and defaulting to
 * "a real error".
 */
export function isAlreadyResolvedIncidentError(error?: Error): boolean {
  return !!error?.message?.toLowerCase().includes('already resolved');
}
